const wowApp = require('angular').module('wowApp.shop');

//Service
wowApp.service('AemPortalService', ['$rootScope', 'Restangular', 'ProductGroupService', 'RREventFactory', '$q', 'rrPlaceHolderCache', 'SavedListsService', 'ShopperService', 'CurrentUserService', 'BwsNotificationService', 'TrolleyService', 'ShopPageStateService', 'DecorateAdditionalDetails', '$uibModal', require('./aem-portal-service')]);
//Directive
wowApp.directive('wowAemPortal', ['$state', require('./aem-portal-directive')]);
wowApp.directive('wowAemPortalXf', ['$state', require('./aem-portal-xf-directive')]);


/** WEBPACK FOOTER **
 ** ./wowapp/src/shop/components/aem/index.js
 **/